const waitForElement = (selector, callback, interval = 50, timeout = 5000) => {
  const startTime = Date.now();
  const timer = setInterval(() => {
    const el = document.querySelector(selector);
    if (el) {
      clearInterval(timer);
      callback(el);
    } else if (Date.now() - startTime > timeout) {
      clearInterval(timer);
      console.warn(`Element ${selector} not found after ${timeout}ms`);
    }
  }, interval);
};

// Example usage
waitForElement(".main-loc-add", (mainLocAdd) => {
  const headerAddressWrap = document.querySelector(".header-address-wrap");
  if (!headerAddressWrap) return;

  mainLocAdd.addEventListener("click", (event) => {
    event.stopPropagation();
    headerAddressWrap.classList.toggle("active");
  });

  document.addEventListener("click", (event) => {
    if (
      !headerAddressWrap.contains(event.target) &&
      !mainLocAdd.contains(event.target)
    ) {
      headerAddressWrap.classList.remove("active");
    }
  });
});

// Close button
waitForElement(".close_loc_btn_wrap", (closeBtn) => {
  const headerAddressWrap = document.querySelector(".header-address-wrap");
  if (!headerAddressWrap) return;

  closeBtn.addEventListener("click", () => {
    headerAddressWrap.classList.remove("active");
  });
});
